import React, { useEffect, useState } from "react"
import { Dialog } from '@headlessui/react'
import { useForm } from "react-hook-form"

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Login = (props) => {
  const { user, submitAction, error, setError, goBack, guestRequest } = props;
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      username: null,
      password: null,
    }
  });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await submitAction(data.username, data.password);
    setLoading(false);
  };
  
  const [formReady, setFormReady] = useState(false || user.loggedIn)
  const [errorMessage, setErrorMessage] = useState('');

  const username = watch('username')
  const password = watch('password')

  useEffect(() => {
    setFormReady((username && username.length > 0) && (password && password.length > 0))
    setError(null)
  }, [username, password]);

  useEffect(() => {
    if (user.loggedIn) {
      setFormReady(true)
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      setErrorMessage(error)
    } else {
      setErrorMessage('')
    }
  }, [error]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-4 text-center">
          <Dialog.Title
            as="h3"
            className="text-md leading-7 font-primary font-bold text-convoy-section-title xl:text-xl"
          >
            {user.loggedIn ? 'Submit your request' : 'Login to submit your request'}
          </Dialog.Title>
          <div>
            <p className="font-primary text-xxs leading-5 text-grey-footer invisible h-0">
              Can’t find what you’re looking for? Fill in a couple fields. Help us learn more about what products you need for your business.
            </p>
          </div>
          {!user.loggedIn && <>
            <div className="mt-3 text-left">
              <label htmlFor="email" className="block font-primary text-convoy-section-title-smaller text-xxs leading-5">
                Email
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  {...register("username", { required: true })}
                  className="focus:outline-none text-grey-footer placeholder-grey-inputPlaceholderText focus:ring-grey-footer border focus:border-grey-footer block w-full border-grey-inputPreFocusBorder rounded-md font-bold px-3 py-input text-xxs leading-3"
                  placeholder="you@email.com"
                />
              </div>
            </div>
            <div className="mt-3 text-left">
              <label htmlFor="password" className="block font-primary text-convoy-section-title-smaller text-xxs leading-5">
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  type="password"
                  {...register("password", { required: true })}
                  className="focus:outline-none text-grey-footer placeholder-grey-inputPlaceholderText focus:ring-grey-footer border focus:border-grey-footer block w-full border-grey-inputPreFocusBorder rounded-md font-bold px-3 py-input text-xxs leading-3"
                />
              </div>
            </div>
          </>}
          {errorMessage.length > 0 && <div className="mt-3">
            <p className="text-sm text-convoy-notificationErrorText">{errorMessage}</p>
          </div>}
          {/* @TODO -- better way of doing this */}
          <div className="mt-3">
            <button
              type="button"
              className="inline-flex justify-center w-full rounded-10 border border-transparent text-center font-bold font-primary text-convoy-section-title focus:outline-none py-4 bg-grey-buttonText text-xxs leading-[1rem]"
              onClick={() => guestRequest()}
            >
              <span>Don’t have an account?<br /><span className="underline font-normal">Continue as a guest</span></span>
            </button>
          </div>

          <div className="mt-3 flex flex-row">
            <button
              type="button"
              className={"text-xs inline-flex justify-center rounded-100 border border-transparent text-center font-black font-primary text-grey-footer focus:outline-none py-3 leading-buttonText flex-1 hover:bg-grey-buttonText items-center"}
              onClick={() => goBack()}
            >
              Go Back
            </button>
            <div className="flex-none w-4"></div>
            <button
              type="submit"
              disabled={!formReady || loading}
              className={"text-xs inline-flex justify-center flex-1 rounded-100 border border-transparent text-center font-black font-primary text-grey-buttonText focus:outline-none py-3 leading-buttonText hover:bg-blue-buttonHover " + classNames(formReady ? "bg-blue-800" : "bg-grey-inputPreFocusBorder")}
            >
              <span className="flex flex-row justify-between">
                {loading && <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>}
                <span className="p-1">Submit Request</span>
              </span>
            </button>
          </div>

        </div>
      </form>
    </div>
  );
};

export default Login;